<template>
  <div>
    <mu-toast v-if="toast" :message="toastmessage" @close="hideToast"/>

    <mu-appbar title="產品列表">
      <mu-flat-button color="white" label="Fb Login" slot="right" @click="signIn" v-show="!auth" />
      <mu-flat-button color="white" label="Sign Out" slot="right" @click="signOut" v-show="auth" />
    </mu-appbar>
    <mu-content-block>
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <h1>所有物品</h1>
          </mu-col>
        </mu-row>
    <div class="demo-grid">
      <mu-row gutter>
          <mu-col v-if="products.length > 0" v-for="(product, index) in productDesc" width="100" tablet="50" desktop="33">
            <mu-card>
              <mu-card-media >
                <img class="product-photo" :src="product.productPhoto" />
              </mu-card-media>
              <mu-card-title :title="product.title" :subTitle="' NT$' + product.price"/>
              <mu-card-text class="text-align-left">
                狀態：{{productState[index]}}<br />
                地點：{{product.address}}
                <pre>{{product.description}}</pre>
              </mu-card-text>
              <mu-card-text class="text-align-left">
                <div v-for="keyword in productSplitArray[index]">
                  <span><a :href="'#'+keyword">#{{keyword}}</a></span>
                </div>
              </mu-card-text>
              <mu-card-header :title="productCreateTime[index] + ' 前建立'" :subTitle="'來自 ' + product.userName">
                <mu-avatar :src="product.userPhotoUrl" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button label="INIT" @click="updateProductState(product, 0)" />
                <mu-flat-button label="X18" @click="updateProductState(product, 1)" />
                <mu-flat-button label="TEST" @click="updateProductState(product, 2)" />
                <mu-flat-button label="DELETE" @click="updateProductState(product, 3)" />
              </mu-card-actions>

<!--               <mu-sub-header>公開討論</mu-sub-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header>
              <mu-card-header title="Myron Avatar" subTitle="哈囉你好">
                <mu-avatar :src="myron" slot="avatar"/>
              </mu-card-header> -->
            </mu-card>
          </mu-col>
        </mu-row>
    </div>
    </mu-content-block>
    <mu-content-block>
      <div class="demo-grid">
        <mu-row gutter>
          <mu-col width="0" tablet="0" desktop="20">
          </mu-col>
          <mu-col v-if="auth" width="100" tablet="50" desktop="30">
            <mu-raised-button class="demo-raised-button" label="上傳圖片">
              <input accept="image/*,capture=camera" @change="saveImageMessage" type="file" class="file-button">
            </mu-raised-button><br />
            <mu-text-field label="物品名稱" type="text" :errorText="(!title) ? '不可空白' : ''" labelFloat v-model="title" /><br/>
            <mu-text-field label="價格" type="number" :errorText="(!price) ?'不可空白' : ''" labelFloat v-model="price" /><br/>
            <mu-text-field label="地點" type="text" hintText="如：台北市大安區" labelFloat v-model="address"/><br/>
            <mu-text-field hintText="(選擇性填寫)敘述你要賣的物品吧，如：尺寸，顏色" multiLine :rows="4" v-model="description"/><br/>
            <mu-text-field label="關鍵字" type="text" hintText="逗點分隔關鍵字，如：nike,puma..." labelFloat v-model="keywords" /><br/>
            <mu-raised-button label="送出" class="demo-raised-button" @click="addProduct" primary/>

          </mu-col>
          <mu-col width="100" tablet="50" desktop="30">
            <mu-card>
              <mu-card-media >
                <img class="product-photo" :src="productPhoto" />
              </mu-card-media>
              <mu-card-title :title="title" :subTitle="' NT$' + price"/>
              <mu-card-text class="text-align-left">
                地點：{{address}}
                <pre>{{description}}</pre>
              </mu-card-text>
              <mu-card-text class="text-align-left">
                <div v-for="keyword in splitArray">
                  <span><a :href="'#'+keyword">#{{keyword}}</a></span>
                </div>
              </mu-card-text>
              <mu-card-header v-if="auth" title="幾秒 前建立" :subTitle="'來自 ' + auth.displayName">
                <mu-avatar :src="auth.photoURL" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-flat-button v-if="auth" :label="'丟訊息問問 ' + auth.displayName" />
              </mu-card-actions>
            </mu-card>
          </mu-col>
          <mu-col width="0" tablet="0" desktop="20">
          </mu-col>
        </mu-row>
      </div>
    </mu-content-block>
  </div>
</template>
<script>
import Firebase from 'firebase'
import {auth, db, storage} from './firebaseApp'
import productPhoto from './assets/images/sun.jpg'
import myron from './assets/images/uicon.jpg'
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'
import {Product} from 'assets/js/state'

var productsRef = db.ref('products')

export default {
  data () {
    return {
      products: [],
      title: '',
      price: '',
      address: '',
      description: '',
      keywords: '',
      auth: null,
      toast: false,
      productPhoto,
      myron
    }
  },
  computed: {
    splitArray () {
      return this.keywords.split(',')
    },
    productSplitArray () {
      return this.products.map((product) => {
        return (product.keywords) ? product.keywords.split(',') : []
      })
    },
    productCreateTime () {
      return this.products.map((product) => {
        return (product.createTime) ? distanceInWordsToNow(product.createTime) : '不知何時'
      })
    },
    productDesc () {
      return this.products.reverse()
    },
    productState () {
      return this.products.map((product) => {
        return (Product.properties[product.state]) ?  Product.properties[product.state].name : null
      })
    }
  },
  methods: {
    addProduct (e) {
      e.preventDefault()
      if (this.title && this.price && this.address) {
        var currentUser = auth.currentUser
        productsRef.push({
          productPhoto: this.productPhoto,
          title: this.title,
          price: this.price,
          address: this.address,
          description: this.description,
          keywords: this.keywords,
          userPhotoUrl: currentUser.photoURL,
          userName: currentUser.displayName,
          createTime: Firebase.database.ServerValue.TIMESTAMP,
          state: Product.INIT
        })
        this.productPhoto = productPhoto
        this.title = ''
        this.price = ''
        this.address = ''
        this.description = ''
        this.keywords = ''
      }
    },
    updateProductState: function (product, state) {
      if (auth.currentUser) {
        productsRef.child(product['.key']).child('state').set(state)
      }
      // @input="updateMessageText(message, event.target.value)"
    },
    signIn () {
      var provider = new Firebase.auth.GoogleAuthProvider()
      auth.signInWithPopup(provider)
    },
    signOut () {
      auth.signOut()
    },
    checkSignedInWithMessage () {
      // Return true if the user is signed in Firebase
      if (auth.currentUser) {
        return true
      }

      // Display a message to the user using a Toast.
      var data = {
        message: 'You must sign-in first',
        timeout: 2000
      }
      this.showToast(data)
      return false
    },
    saveImageMessage (event) {
      var file = event.target.files[0]

      // Check if the file is an image.
      if (!file.type.match('image.*')) {
        var data = {
          message: 'You can only share images',
          timeout: 2000
        }
        this.showToast(data)
        return
      }

      // Check if the user is signed-in
      if (this.checkSignedInWithMessage()) {
        // We add a message with a loading icon that will get updated with the shared image.
        var currentUser = auth.currentUser

        // Upload the image to Firebase Storage.
        storage.ref(currentUser.uid + '/' + Date.now() + '/' + file.name)
            .put(file, {contentType: file.type})
            .then((snapshot) => {
              // Get the file's Storage URI and update the chat message placeholder.
              var filePath = snapshot.metadata.fullPath
              return storage.ref(filePath).getDownloadURL()
            }).then((url) => {
              this.productPhoto = url
            }).catch((error) => {
              console.error('There was an error uploading a file to Firebase Storage:', error)
            })
      }
    },
    showToast (data) {
      this.toast = true
      this.toastmessage = data.message
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, data.timeout)
    },
    hideToast () {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    }
  },
  beforeCreate () {
    auth.onAuthStateChanged((user) => {
      this.auth = user
      this.$bindAsArray('products', productsRef.limitToLast(25))
    })
  }
}
</script>
<style lang="css">
.demo-grid div[class*="col-"] {
  background: #fff;
  color: #000;
  padding: 8px;
  margin-bottom: 8px;
  margin-left:auto;
  margin-right:auto;
}
.text-align-left {
  text-align: left;
  word-break: break-all;
}
.file-button{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
}

.demo-raised-button {
  margin: 12px;
}
.product-photo {
  max-height: 200px;
}
</style>


// WEBPACK FOOTER //
// Home.vue?00cbfff9